import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.header`
  display: flex;
  flex-direction: row;
  padding: 16px 24px;
  border-bottom: 1px solid ${ColorPalette.HEX.BrightGray};
`;

export const Title = styled.h5`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  color: ${({ theme }) => theme.hotelDetails.subtitleColor};
`;

export const SeeMore = styled.button`
  font-size: 12px;
  margin-left: auto;
  font-weight: 600;
  text-align: center;
  color: ${({ theme }) => theme.hotelDetails.seeMore};
  background-color: ${({ theme }) => theme.hotelDetails.background};
  cursor: pointer;
`;
